import useBaseLinks from 'store/Auth/Links/useBaseLinks';
import { parseTemplate } from 'url-template';
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query';
import { useGetCustomerHoleDetectionsQuery } from 'store/_Api/HoleDetection';
import { useEffect, useState } from 'react';
import { HoleDetectionsApiResponse } from 'models/holeDetection';
import { SerializedError } from '@reduxjs/toolkit';

type HoleListReturn = {
  holes: HoleDetectionsApiResponse['collection'];
  isFetching: boolean;
  error: FetchBaseQueryError | SerializedError | unknown;
};

type Props = {
  pen?: string;
};

type Params = {
  pen?: string;
  site_uuid: string;
};

const useDeviationList = (props?: Props): HoleListReturn => {
  const [holeDetectionLinkWithSiteId, setHoleDetectionLink] = useState('');

  const { getLink, selectedSiteUuid } = useBaseLinks();
  const getDaviationsLink = getLink('holes');
  const {
    data: holeDetectionData,
    isFetching,
    error,
  } = useGetCustomerHoleDetectionsQuery(
    holeDetectionLinkWithSiteId ?? skipToken,
  );
  const holes = holeDetectionData?.collection || [];

  useEffect(() => {
    if (getDaviationsLink && selectedSiteUuid) {
      const urlTemplate = parseTemplate(
        decodeURIComponent(getDaviationsLink.replace(/\+/g, ' ')),
      );

      const params: Params = {
        site_uuid: selectedSiteUuid,
      };

      if (props?.pen) {
        params.pen = props?.pen;
      }

      setHoleDetectionLink(urlTemplate.expand(params));
    }
  }, [getDaviationsLink, selectedSiteUuid, props?.pen]);

  return {
    holes,
    isFetching,
    error,
  };
};

export default useDeviationList;
